import { LeaderboardAllDto } from '../../../models/dtos/leaderboardAll.dto';
import axios from '../../axios';

export default async function getLeaderboardAllTeamsRequest(
): Promise<LeaderboardAllDto[]> {
  const response = await axios.get<LeaderboardAllDto[]>(
    `${process.env.REACT_APP_BASE_URL}/leaderboard/team`
  );
  return response.data;
}
